import localizedStr, { EN_US, ES_US, SupportedLocale } from '../../../core/util/localizedStr';
import {
  TYPE_HMO,
  TYPE_PPO,
  TYPE_MEDICARE,
  TYPE_MEDICAID,
  TYPE_TRICARE,
  TYPE_OTHER,
  TYPE_UNKNOWN,
} from '../../../constants/index';
import { capitalCase } from '../../../core/util/string';
import { neverDefault } from '../../../core/util/neverDefault';

const universalOptions = [
  { key: TYPE_HMO, label: 'HMO' },
  { key: TYPE_PPO, label: 'PPO' },
  { key: TYPE_MEDICARE, label: 'Medicare' },
  { key: TYPE_MEDICAID, label: 'Medicaid' },
  { key: TYPE_TRICARE, label: 'Tricare' },
];

const makeOptions = (locale: SupportedLocale) => [
  ...universalOptions,
  { key: TYPE_OTHER, label: capitalCase(localizedStr[locale].OTHER, { locale }) },
  { key: TYPE_UNKNOWN, label: capitalCase(localizedStr[locale].DONT_KNOW, { locale }) },
];

const enOptions = makeOptions(EN_US);
const esOptions = makeOptions(ES_US);

export const getInsuranceTypes = (locale?: SupportedLocale) => {
  if (locale == null || locale === EN_US) {
    return enOptions;
  }

  if (locale === ES_US) {
    return esOptions;
  }

  return neverDefault(locale, enOptions);
};

export default enOptions;
